/**
 *
 * @param {Object} props - Component properties
 * @param {Array<{label: string, value: number}>} props.chartData
 * @example
 * const data = {
 *   facebook: [{
 *      "date": "2025-03-24",
 *      "impressions": 3868,
 *      "clicks": 30,
 *      "ctr": 0.7755946225439504,
 *      "shares": 0,
 *      "comments": 0,
 *      "likes": 0
 *   }],
 * }
 */
export const useTransformData = (chartData, selectedChannel) => {
  if (!chartData) return null;

  const channelKeys = Object.keys(chartData).filter((key) => key !== "allChannelsAverage");

  const result = {
    totalImpressions: [],
    totalClicks: [],
    totalComments: [],
    totalReactions: [],
    totalShares: [],
    ctr: [],
    allMetrics: []
  };

  const allMetrics = {
    impressions: 0,
    clicks: 0,
    ctr: 0,
    comments: 0,
    likes: 0,
    shares: 0
  };

  let ctrSum = 0;

  // Step 1: Use selectedChannel data if provided, otherwise use allChannelsAverage
  const baseData = selectedChannel ? chartData[selectedChannel] : chartData.allChannelsAverage;

  if (baseData?.length > 0) {
    for (const entry of baseData) {
      allMetrics.impressions += entry.impressions || 0;
      allMetrics.clicks += entry.clicks || 0;
      ctrSum += entry.ctr || 0;
      allMetrics.comments += entry.comments || 0;
      allMetrics.likes += entry.likes || 0;
      allMetrics.shares += entry.shares || 0;
    }
    allMetrics.ctr = parseFloat((ctrSum / baseData.length).toFixed(2));
  }

  result.allMetrics = allMetrics;

  // Step 2: Loop through the active channels
  for (const channel of channelKeys) {
    const data = chartData[channel] || [];

    let totalImpressions = 0;
    let totalClicks = 0;
    let totalComments = 0;
    let totalLikes = 0;
    let totalShares = 0;

    for (const entry of data) {
      totalImpressions += entry.impressions || 0;
      totalClicks += entry.clicks || 0;
      totalComments += entry.comments || 0;
      totalLikes += entry.likes || 0;
      totalShares += entry.shares || 0;
    }

    // use formatIntlNumber ?
    const ctrValue =
      totalImpressions > 0 ? ((totalClicks / totalImpressions) * 100).toFixed(2) : "0.00";

    result.totalImpressions.push({ name: channel, value: totalImpressions });
    result.totalClicks.push({ name: channel, value: totalClicks });
    result.totalComments.push({ name: channel, value: totalComments });
    result.totalReactions.push({ name: channel, value: totalLikes });
    result.totalShares.push({ name: channel, value: totalShares });
    result.ctr.push({ name: channel, value: ctrValue });
  }

  return { result, channelKeys };
};
